import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import { lazy, Suspense } from 'react'

const TechnicalDashboard = lazy(() => import('./Dashboard'))

const LoadingFallback = () => (
    <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
    </div>
)

const TechnicalModule: RouteObject = {
    path: 'technical',
    children: [
        {
            path: '',
            element: (
                <Suspense fallback={<LoadingFallback />}>
                    <TechnicalDashboard />
                </Suspense>
            ),
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default TechnicalModule
